import { observer } from 'mobx-react-lite';
import { getEffectiveFolderDisplayName } from 'owa-folders';
import getFolderViewStateFromId from 'owa-mail-folder-store/lib/selectors/getFolderViewStateFromId';
import * as React from 'react';
import { MailFolderNodeTreeDocument } from './__generated__/MailFolderNodeTreeQuery.interface';
import {
    MailFolderNode,
    MailFolderNodeChildren,
    MailFolderNodeTreeProps,
} from 'owa-mail-folder-view';
import { useManagedQuery } from 'owa-apollo-hooks';

/**
 * Component responsible for rendering the Node and then its children
 */
export default observer(function MailFolderNodeTree(props: MailFolderNodeTreeProps) {
    const { data } = useManagedQuery(MailFolderNodeTreeDocument, {
        variables: {
            id: props.folderId,
            mailboxInfo: props.mailboxInfo,
        },
        fetchPolicy: 'cache-first',
    });

    if (!data) {
        return null;
    }

    const folder = data.folder;

    const renderNodeSubTree = (): JSX.Element => {
        const {
            folderId,
            isFavoritesSupported,
            nestDepth,
            onContextMenu,
            treeType,
            mailboxInfo,
            distinguishedFolderParentIds,
            moveFolder,
        } = props;

        /**
         * Add child nodes of this node if the node is expanded
         */
        const viewState = getFolderViewStateFromId(folderId);
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2533 (50,33): Object is possibly 'null' or 'undefined'.
        // @ts-expect-error
        const hasChildFolders = folder.childFolderIds && folder.childFolderIds.length > 0;
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (54,37): Object is possibly 'undefined'.
        // @ts-expect-error
        const shouldRenderSubTree = viewState.isExpanded && hasChildFolders;
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (58,74): Argument of type 'Maybe<{ __typename?: "MailFolder" | undefined; } & { __typename?: "MailFolder" | undefined; } & Pick<MailFolder, "displayName" | "distinguishedFolderType" | "childFolderIds"> & { ...; } & { ...; } & Pick<...>> | undefined' is not assignable to parameter of type 'Pick<MailFolder, "displayName" | "remoteFolderInfo">'.
        // @ts-expect-error
        const effectiveFolderDisplayName = getEffectiveFolderDisplayName(folder);
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2488 (62,50): Type 'string[] | undefined' must have a '[Symbol.iterator]()' method that returns an iterator.
        // @ts-ignore
        let newDistinguishedFolderParenIds = [...distinguishedFolderParentIds];
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2533 (66,13): Object is possibly 'null' or 'undefined'.
        // @ts-expect-error
        if (folder.distinguishedFolderType) {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2533 (70,49): Object is possibly 'null' or 'undefined'.
            // @ts-expect-error
            newDistinguishedFolderParenIds.push(folder.distinguishedFolderType);
        }

        return (
            <>
                {/* Render folder node tree*/}
                <MailFolderNode
                    key={folderId}
                    depth={nestDepth}
                    folderId={folderId}
                    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                    // -> Error TS2532 (83,37): Object is possibly 'undefined'.
                    // @ts-expect-error
                    isBeingDragged={viewState.drag.isBeingDragged}
                    onContextMenu={onContextMenu}
                    shouldHideToggleFavorite={!isFavoritesSupported}
                    treeType={treeType}
                    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                    // -> Error TS2322 (90,21): Type 'Maybe<{ __typename?: "MailFolder" | undefined; } & { __typename?: "MailFolder" | undefined; } & Pick<MailFolder, "displayName" | "distinguishedFolderType" | "childFolderIds"> & { ...; } & { ...; } & Pick<...>> | undefined' is not assignable to type 'MailFolderNodeFragment'.
                    // @ts-expect-error
                    folder={folder}
                    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                    // -> Error TS2322 (94,21): Type 'MailboxInfoInput | undefined' is not assignable to type 'MailboxInfo'.
                    // @ts-expect-error
                    mailboxInfo={mailboxInfo}
                    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                    // -> Error TS2322 (98,21): Type 'boolean | null | undefined' is not assignable to type 'boolean'.
                    // @ts-expect-error
                    isFolderExpandable={hasChildFolders}
                    effectiveFolderDisplayName={effectiveFolderDisplayName}
                    distinguishedFolderParentIds={distinguishedFolderParentIds}
                    moveFolder={moveFolder}
                />

                {/* Render sub node tree*/}
                {shouldRenderSubTree && (
                    <MailFolderNodeChildren
                        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                        // -> Error TS2322 (110,25): Type 'Maybe<string[]> | undefined' is not assignable to type 'string[]'.
                        // @ts-expect-error
                        folderIdsToRender={folder.childFolderIds}
                        nestDepth={nestDepth + 1}
                        treeType={treeType}
                        isFavoritesSupported={isFavoritesSupported}
                        onContextMenu={onContextMenu}
                        renderFolderNode={props.renderFolderNode}
                        distinguishedFolderParentIds={newDistinguishedFolderParenIds}
                    />
                )}
            </>
        );
    };

    return <>{renderNodeSubTree()}</>;
});
